import React, { useState } from "react"
import * as styles from "./Gallery.module.css"
import ImageModal from "../projects/enchanted/ImageModal"
import interiorImage12 from "../../images/on-going-projects/the-edge/gallery/05.png";
import interiorImage13 from "../../images/on-going-projects/the-edge/gallery/06.png";
import interiorImage14 from "../../images/on-going-projects/the-edge/gallery/07.png";
import interiorImage15 from "../../images/on-going-projects/the-edge/gallery/08.png";
import interiorImage16 from "../../images/on-going-projects/the-edge/gallery/09.png";

import exteriorImage1 from "../../images/on-going-projects/the-edge/gallery/02.png";
import exteriorImage2 from "../../images/on-going-projects/the-edge/gallery/03.png";
import exteriorImage3 from "../../images/on-going-projects/the-edge/gallery/10.jpg"; 
import exteriorImage4 from "../../images/on-going-projects/the-edge/gallery/12.png";


const Gallery = () => {
  const [activeTab, setActiveTab] = useState("interior")
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedImage, setSelectedImage] = useState(null)

  const galleries = {
    interior: [
       {
            src: interiorImage12,
            alt: "gallery image",
          },
          {
            src: interiorImage13,
            alt: "gallery image",
          },
          {
            src: interiorImage14,
            alt: "gallery image",
          },
          {
            src: interiorImage15,
            alt: "gallery image",
          },
             {
            src: interiorImage16,
            alt: "gallery image",
          },
    ],
    exterior: [
       {
            src: exteriorImage1,
            alt: "gallery image",
          },
          {
            src: exteriorImage2,
            alt: "gallery image",
          },
          {
            src: exteriorImage3,
            alt: "gallery image",
          },
          {
            src: exteriorImage4,
            alt: "gallery image",
          },
    ]
  }

  const openModal = (imageSrc, gallery) => {
    const images = galleries[gallery]
    const imageIndex = images.indexOf(imageSrc)
    setSelectedImage(imageIndex + 1)
    setIsModalOpen(true)
  }

  return (
    <>
      <section className={styles.projectStatusSection} id="gallery">
        <h2 className={styles.psTitle2}> Project <span className={styles.cbr}>Gallery</span></h2>

        {/* Tabs */}
        <div className={styles.psTabs}>
          <button
            className={`${styles.psTab} ${activeTab === "interior" ? styles.active : ""}`}
            onClick={() => setActiveTab("interior")}
          >
            Interior
          </button>
          <button
            className={`${styles.psTab} ${activeTab === "exterior" ? styles.active : ""}`}
            onClick={() => setActiveTab("exterior")}
          >
            Exterior
          </button>
        </div>

        {/* Interior Gallery */}
        <div className={`${styles.psGallery} ${activeTab === "interior" ? styles.show : ""}`}>
          {galleries.interior.map((img, index) => (
            <img
              key={index}
              src={img.src}
              alt={img.alt}
              onClick={() => openModal(img, "interior")}
            />
          ))}
        </div>

        {/* Exterior Gallery */}
        <div className={`${styles.psGallery} ${activeTab === "exterior" ? styles.show : ""}`}>
          {galleries.exterior.map((img, index) => (
            <img
              key={index}
              src={img.src}
              alt={img.alt}
              onClick={() => openModal(img, "exterior")}
            />
          ))}
        </div>
      </section>

      {/* Image Modal */}
      {isModalOpen && (
        <ImageModal
          imagesArray={activeTab === "interior" ? galleries.interior : galleries.exterior}
          selectedImage={selectedImage}
          setSelectedImage={setSelectedImage}
          showModal={isModalOpen}
          setShowModal={setIsModalOpen}
        />
      )}
    </>
  )
}

export default Gallery
